import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const OrganisationViewModule = new Module({
  id: 'ORGANISATION-OPERATION:VIEW:RESULT-TABLE',
  name: 'Organisation',
  path: 'organisation',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Organisation/View'))
  ),
});

export const OrganisationAddModule = new Module({
  id: 'ORGANISATION-OPERATION:CREATE:ORGANISATION',
  name: 'add-organisation',
  path: 'organisation/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Organisation/Form/add'))
  ),
  // actions: {
  //   add: {
  //     id: 'ORGANISATION-OPERATION:CREATE:ORGANISATION',
  //     name: 'add-organisation',
  //     label: 'Add organisation'
  //   }
  // }
});

export const OrganisationEditModule = new Module({
  id: 'ORGANISATION-OPERATION:EDIT-ORGANISATION',
  name: 'OrganisationEdit',
  path: 'organisation/edit',
  pathDef: 'organisation/edit/:id',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Organisation/Form/edit'))
  ),
  actions: {
    edit: {
      id: 'ORGANISATION-OPERATION:EDIT-ORGANISATION',
      name: 'edit-organisation-result-table',
      label: 'Edit'
    },
    delete: {
      id: 'ORGANISATION-OPERATION:DELETE:RESULT-TABLE',
      name: 'delete-organisation-result-table',
      label: 'Delete'
    },
    sendMail: {
      id: 'send-mail-item',
      name: 'send-mail-item',
      label: 'Send Mail'
    },
    opensetting: {
      id: 'ORGANISATION-OPERATION:VIEW:OPEN-SETTINGS',
      name: 'setting-organisation',
      label: 'Open Settings'
      
    },
  }
});



const OrganisationModules = [
  OrganisationViewModule,
  OrganisationEditModule,
  OrganisationAddModule
];

export default new ModuleBundle('Organisation', OrganisationModules);
